import { PaymentResultComponent } from './payment-result/payment-result.component';
import { PaymentSecuritiesService } from './services/payment-securities.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRadioModule, MatCheckboxModule, MatButtonModule, MatListModule, MatDatepickerModule } from '@angular/material';
import { PaymentDataComponent } from './payment-data/payment-data.component';
import { PaymentSecuritiesComponent } from './payment-securities.component';
import { SharedModule } from '../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CurrencyMaskModule } from 'ngx-currency-mask';
import { PaymentSecuritiesConfirmationComponent } from './payment-securities-confirmation/payment-securities-confirmation.component';
import { ReceiptsModule } from '../receipts/receipts.module';
import { PaymentReceiptsService } from './services/payment-receipt.service';
import { PaymentResponseHandlerService } from './services/payment-response-handler';

@NgModule({
	imports: [
		CommonModule,
		MatRadioModule,
		MatCheckboxModule,
		MatButtonModule,
		MatListModule,
		SharedModule,
		MatDatepickerModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		CurrencyMaskModule,
		ReceiptsModule
	],
	declarations: [
		PaymentSecuritiesComponent,
		PaymentDataComponent,
		PaymentSecuritiesConfirmationComponent,
		PaymentResultComponent
	],
	providers: [PaymentSecuritiesService, PaymentReceiptsService, PaymentResponseHandlerService]
})
export class PaymentSecuritiesModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/payment-securities/payment-securities.module.ts